import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ServiceHelper } from '../config';
import { UnitOfMeasureModel } from '../models';
import { AppConfig } from '../config';

@Injectable()
export class UnitOfMeasureService {
    readonly baseEndpoint: string = '/unit-of-measures/';

    constructor(public http: HttpClient, public serviceHelper: ServiceHelper, private appConfig: AppConfig) {
        var that = this;
    }

    FindAll(auctionId: number): Observable<UnitOfMeasureModel[]> {
        var headers = this.serviceHelper.GetHeaders();

        return this.http.get<UnitOfMeasureModel[]>(this.appConfig.getConfig('apiUrl') + this.baseEndpoint + (auctionId ? `auction/${auctionId}` : ''), { withCredentials: true, headers: headers });
    }
    Filter(term: string): Observable<UnitOfMeasureModel[]> {
        var headers = this.serviceHelper.GetHeaders();

        return this.http.get<UnitOfMeasureModel[]>(this.appConfig.getConfig('apiUrl') + this.baseEndpoint + 'filter/' + encodeURIComponent(term), { withCredentials: true, headers: headers });
    }
}